(function(){
    angular
        .module('appback')
        .directive('ngCoa', coa);
        coa.$inject = ['HojaService','$timeout', 'Upload'];
        function coa(HojaService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=coa.twig',
		          scope: {
                  hc:"="
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.coa = {};
                        scope.init = function(){
                            HojaService.getCoa(scope.hc.idhojafabricacionactiva, scope.hc.hojafabricacionactiva.material_id, function(dataCoa){
                                console.log("coa",dataCoa);
                                scope.coa = dataCoa.coa;
                            });
                        }
                        scope.init();
			        });
		        }
          }
      }
})();